import _camelCase from 'lodash/camelCase';

const extractGlobImports = (
  importFiles: Record<string, unknown>,
  regexPattern: RegExp,
) => {
  const imports: Record<string, any> = {};

  for (const path in importFiles) {
    const match = path.match(regexPattern);
    if (match && match[1]) {
      const key = _camelCase(match[1]);
      imports[key] = importFiles[path];
    }
  }

  return imports;
};

export default extractGlobImports;
